<template>
    <div>
        <h3>Matchmaking algorithm:</h3>
        <p>
            With 7 other players alive, you will not revisit the last 4 you have faced.<br>
            With 6 others alive, the last 3.<br>
            With 5 others alive, the last 2.<br>
            With 3 or 4 others alive, you will not visit the last player you faced.<br>
        </p>
        <p>When someone is eliminated, the match history is reset, so you can fight anyone.</p>
    </div>
</template>

<script>
    export default {
        name: "MatchmakingAlgorithm"
    }
</script>

<style>
</style>